import isHybridEnabledCSR from '@/app/api/CSR/isHybridEnabledCSR'

const parseSearchForHybrid = (queryString: string) =>
  // TODO remove
  isHybridEnabledCSR()
    ? `/search?name=${queryString}`
    : `/search?name=${queryString}`

export default parseSearchForHybrid
